module.exports = __webpack_public_path__ + "static/media/DSC_3930.8e1646a1.png";